
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedLowUp as ObiSpeedLowUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-low-up.js';
 
 
 

 
 export const ObiSpeedLowUp = createComponent({
   react: React,
   tagName: 'obi-speed-low-up',
   elementClass: ObiSpeedLowUpElement,
   events: {
     
   }
  });
 
 